import { render, staticRenderFns } from "./GlowButton.vue?vue&type=template&id=24dbbe93&scoped=true"
import script from "./GlowButton.vue?vue&type=script&lang=js"
export * from "./GlowButton.vue?vue&type=script&lang=js"
import style0 from "./GlowButton.vue?vue&type=style&index=0&id=24dbbe93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dbbe93",
  null
  
)


    import installComponents from "!/home/gitlab-runner/builds/_LQxgyuP/0/skolkovo/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton} from 'bootstrap-vue'
    installComponents(component, {BButton})
    

export default component.exports